import React, {useState} from "react";
import { Link } from "react-router-dom";
import { Input } from 'antd';
import { Col, Row, FormGroup, Modal, Button, Container, Form} from "react-bootstrap";
import { Breadcrumb, ImageElement, LoginHeader} from "../../components";
import TextArea from "antd/lib/input/TextArea";
function Rating() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'My Booking / Rating',
        },
    ];
        // modal
        const [show, setShow] = useState(false);
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(true);
    return(
        <>            
            <LoginHeader/>         
            <div className="main-content ratingPage">
                {/* page content */}
                <div className="pageContent">
                    <div className="pageContent_wide">
                        <Container className="container-lg">
                            <Breadcrumb title="Rating" breadcrumb={breadcrumb}/>
                            <Form>
                                <div className="ratingPage_Box br-10 p-30 bg-white">
                                    <div className="ratingPage_Booking  mb-3 mb-sm-4 d-sm-flex justify-content-between align-items-end">
                                        <div className="ratingPage_Booking_left">
                                            <h2 className="mb-0">Total</h2>
                                            <h3 className="mb-0">$ 255.00</h3>
                                            <ul className="list-unstyled mb-0">
                                                <li className="d-sm-flex align-items-md-center"> <em className="gg-calendar me-1"/> <span className="flex-shrink-0">Booking Date : </span><span>Thu, March 6, 2019 at 04:03 PM</span></li>
                                                <li className="d-sm-flex align-items-md-center"> <em className="gg-discount me-1"/> <span>Discount Applied : </span><span>15% Off</span></li>
                                            </ul>
                                        </div>
                                        <div className="ratingPage_Booking_right">
                                            <Button type="button" variant="info" className="btn btn-info mt-2 mt-sm-0">Get Receipt</Button>
                                        </div>
                                    </div>
                                    <div className="ratingPage_Payment">
                                        <div className="ratingPage_Payment_type">
                                            <p>Payment Type: <span>Credit Card</span></p>
                                        </div>
                                        <div className="ratingPage_Services">
                                            <h4 className="ratingheading mb-0"> Services</h4>
                                            <div className="ratingPage_Services_inner d-flex justify-content-between align-items-end">
                                                <div className="ratingPage_Services_maintenance">
                                                    <h5 className="ratingsubhead mb-2"> Heating Maintenance</h5>
                                                    <p className="ratingpara mb-0">Heating Maintenance</p>
                                                </div>
                                                <p className="ratingamount mb-0">$100.00</p>
                                            </div>
                                        </div>
                                        <div className="ratingPage_Services">
                                            <h4 className="ratingheading mb-0"> Customer Image</h4>
                                            <div className="ratingPage_Services_image">
                                                <ImageElement source="customer-img.png" alt="user"/>
                                            </div>
                                            <h4 className="ratingheading mb-0">Line Items</h4>
                                            <div className="ratingPage_Services_inner d-flex justify-content-between align-items-start">
                                                <div className="d-sm-flex">
                                                    <ImageElement source="water-heater.png" className="me-2 mb-2" alt="water-heater"/>
                                                    <div className="ratingPage_Services_items">
                                                        <h5 className="ratingsubhead mb-sm-2 mb-1"> Heating Maintenance</h5>
                                                        <p className="ratingpara mb-0">Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first.</p>
                                                    </div>
                                                </div>
                                                <p className="ratingamount mb-0">$50.00</p>
                                            </div>
                                        </div>
                                        <div className="ratingPage_Services">
                                            <div className="ratingPage_Services_inner d-flex justify-content-between align-items-center mt-0">
                                                <h5 className="ratingsubhead mb-0 ratingPage_desc"> Promo Code Discount</h5>
                                                <p className="ratingsubhead mb-0 ratingPage_amount">15%</p>
                                            </div>
                                        </div>
                                        <div className="ratingPage_Services">
                                            <div className="ratingPage_Services_inner d-flex justify-content-between align-items-center mt-0">
                                                <h5 className="ratingsubhead mb-0 ratingPage_desc">Subtotal</h5>
                                                <p className="ratingsubhead mb-0 ratingPage_amount">$150.00</p>
                                            </div>
                                            <div className="ratingPage_Services_inner d-flex justify-content-between align-items-center my-sm-3 my-2">
                                                <h5 className="ratingsubhead mb-0 ratingPage_desc">Promo Code Discount</h5>
                                                <p className="ratingsubhead mb-0 ratingPage_amount">15%</p>
                                            </div>
                                            <div className="ratingPage_Services_inner d-flex justify-content-between align-items-center mt-0">
                                                <h5 className="ratingsubhead mb-0 ratingPage_desc">Total</h5>
                                                <p className="ratingsubhead mb-0 ratingPage_amount">$127.05</p>
                                            </div>
                                        </div>
                                        <div className="ratingPage_Services">
                                                <h5 className="ratingsubhead mb-2">
                                                    Invoice Message
                                                </h5>
                                                <p className="ratingpara mb-0">Lorem Ipsum generators on the Internet tend to repeat redefined chunks as necessary, making this the first...</p>
                                            </div>
                                        <div className="ratingPage_Services  border-0 pb-0">
                                            <h4 className="ratingheading text-center mb-2 mb-md-3"> How Was Your Service </h4>
                                            <div class="rating d-flex starRating justify-content-center">
                                                <input id="star-a1" type="radio" name="rating-a" value="star-a1" />
                                                <label for="star-a1">
                                                    <em className="info_icon info_icon-gray gg-star-outline"/>
                                                </label>
                                                <input id="star-a2" type="radio" name="rating-a" value="star-a2" />
                                                <label for="star-a2">
                                                    <em className="info_icon info_icon-gray gg-star-outline"/>
                                                </label>
                                                <input id="star-a3" type="radio" name="rating-a" value="star-a3" />
                                                <label for="star-a3">
                                                    <em className="info_icon info_icon-gray gg-star-outline"/>
                                                </label>
                                                <input id="star-a4" type="radio" name="rating-a" value="star-a4" />
                                                <label for="star-a4">
                                                    <em className="info_icon info_icon-gray gg-star-outline"/>
                                                </label>
                                                <input id="star-a5" type="radio" name="rating-a" value="star-a5" />
                                                <label for="star-a5">
                                                    <em className="info_icon info_icon-gray gg-star-outline"/>
                                                </label>
                                            </div>
                                                <FormGroup className="form-group">
                                                    <TextArea size="large" placeholder="Enter Your Comment" className="bg-white"/>
                                                </FormGroup>
                                        </div>
                                    </div>
                                        <div className="d-flex justify-content-end mt-sm-4 mt-3">
                                            <button type="button" className="ms-4 font-sm btn btn-primary min-200 btn-lg" onClick={handleShow} >Rate</button>
                                        </div>
                                </div>
                            </Form>
                            <div className="sideBar_bottom mt-3">
                                <p className="text-center mb-sm-3 mb-2">Meet the new Good Guys Service Mobile app</p>
                                <div className="d-flex justify-content-center">
                                    <Link className="me-2"><ImageElement source="google-play-logo.svg" className="w-100 img-fluid" alt="Google-play" /></Link>
                                    <Link className="mt-0"><ImageElement source="app-store-logo.svg"  className="w-100 img-fluid" alt="App-play" /></Link>
                                </div>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
            <Modal show={show} onHide={handleClose} size="md" centered id="servicecomplate" className="servicecomplate" backdrop="static">
                <Modal.Body>
                    <div className="text-center">
                        <ImageElement source="service-complated.svg" alt="service-complated"/>
                        <h2>Service Completed</h2>
                        <p className="mb-0">Current Booking is Successfully <br/> Completed</p>
                    </div>
                    <div className="text-center">
                        <h3>Leave a review on </h3>
                        <div className="servicecomplate_review">
                            <ul className="list-unstyled d-flex justify-content-center">
                                <li><Link><span> <ImageElement source="google.svg" alt="google"/></span>Google</Link></li>
                                <li><Link><span> <ImageElement source="fb.svg" alt="facebook"/></span>Facebook</Link></li>
                            </ul>
                        </div>
                        <Link to="/dashboard" className="skip">SKIP</Link>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default Rating;